import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { GlobalErrorBoundary } from "./components/GlobalErrorBoundary";
import "./lib/devLoggingInstance";
import { AppProviders } from "./providers/AppProviders";
import "./styles/global.css";
import { applyColorOverrides, isDevOrStaging } from "./lib/colorOverrides";

// Apply developer color overrides synchronously (dev/staging only)
// This runs before React renders to prevent flash of default colors
if (isDevOrStaging()) {
  applyColorOverrides();
}

// Global error handlers - errors are captured by HyperDX via consoleCapture
window.onerror = (_msg, _src, _line, _col, err) => {
  console.error("Uncaught error:", err);
};
window.onunhandledrejection = (event) => {
  console.error("Unhandled rejection:", event.reason);
};

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element with id 'root' is missing");
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <GlobalErrorBoundary>
      <BrowserRouter>
        <AppProviders>
          <App />
        </AppProviders>
      </BrowserRouter>
    </GlobalErrorBoundary>
  </StrictMode>
);
